import { SVGProps } from './types';

const CircleTickIcon = (props: SVGProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
      {...props}
    >
      <g clipPath="url(#clip0_1254_140262)">
        <path
          fill="#fff"
          d="M0 12C0 5.373 5.373 0 12 0s12 5.373 12 12-5.373 12-12 12S0 18.627 0 12z"
        />
        <path
          fill="#079455"
          d="M0 12C0 5.373 5.373 0 12 0s12 5.373 12 12-5.373 12-12 12S0 18.627 0 12z"
        />
        <path
          stroke="#fff"
          strokeLinecap="square"
          strokeWidth="2"
          d="M17.333 8L10 15.333 6.667 12"
        />
      </g>
      <defs>
        <clipPath id="clip0_1254_140262">
          <path
            fill="#fff"
            d="M0 12C0 5.373 5.373 0 12 0s12 5.373 12 12-5.373 12-12 12S0 18.627 0 12z"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export { CircleTickIcon };
